<h1 mat-dialog-title>Container Photos</h1>
<div mat-dialog-content>

  <div class="row">
    <div class="col-4">
      <strong>Container ID:</strong> {{data.container_id}}
    </div>
    <div style="text-align: center;" class="col-4">
      <strong>Type:</strong> {{data.type}}
    </div>
    <div *ngIf="data.po" style="text-align: right;" class="col-4">
      <strong>PO#</strong> {{data.po}}
    </div>
  </div>

  <div *ngIf="container">

    <br><br>

    <form>
      <div class="row">
        <div class="col-4">

          <div class="form-group">
            <label for="warehouse">Warehouse</label>
            <input type="text" class="form-control" id="warehouse" name="warehouse" [(ngModel)]="container.internalLocation.location.name" disabled>
          </div>

        </div>
        <div class="col-4">

          <div class="form-group">
            <label for="itemtype">Item Type</label>
            <input type="text" class="form-control" id="itemtype" name="itemtype" [(ngModel)]="container.item" disabled>
          </div>

        </div>
        <div class="col-4">

          <div class="form-group">
            <label for="is_pi">Stage</label>
            <select id="is_pi" name="is_pi" [(ngModel)]="container.isPi" class="form-control" disabled>
              <option value=null disabled>Please select an option</option>
              <option value='1'>1st</option>
              <option value='0'>2nd</option>
              <option value='3'>3rd</option>
              <option value='4'>4th</option>

            </select>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label>Total Weight</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" name="weight" [(ngModel)]="container.weight" disabled aria-label="Recipient's username" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">Lbs</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>NET Weight</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" name="totalNetWeight" [(ngModel)]="container.totalNetWeight" disabled aria-label="Recipient's username" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">Lbs</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">

          <div class="form-group">
            <label for="damages">Damages</label>
            <input type="text" class="form-control" id="damages" name="damages" [(ngModel)]="container.damages" disabled>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-6">

          <div class="form-group">
            <label for="typeEquipment">Type Of Equipment</label>
            <input type="text" class="form-control" id="typeEquipment" name="typeEquipment" [(ngModel)]="container.typeEquipment" disabled>
          </div>

        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="location">Location</label>
            <input type="text" class="form-control" id="location" name="location" [value]="locationName(container.internalLocation)" disabled>
          </div>
        </div>
      </div>
    </form>


  </div>

  <br>

  <div style="text-align: center;" id="qrcode"></div>

  <!-- <div style="text-align: center;" id="createPNGButton">
    <button class="btn btn-info" (click)="putImage()">
      <span class="material-icons">file_download</span> Download QR
    </button>
  </div> -->

  <div style="text-align: center;" id="createPNGButton">
    <button class="btn btn-info" (click)="getPhotos();" [disabled]="loadingContainer || loading">
      <!-- <span class="material-icons">file_download</span> -->
      <i *ngIf="loadingContainer || loading" class="fa fa-circle-o-notch fa-spin fa-fw"></i> &nbsp; Done! Pictures uploaded!
    </button>
    &nbsp;&nbsp;
    <button *ngIf="container && container.pictureRequired && container.numPhotos" class="btn btn-default" (click)="printlabel()">
      <!-- <span class="material-icons">file_download</span> -->
      <i class="fa fa-print" aria-hidden="true"></i> &nbsp; PRINT LABEL
    </button>
  </div>

  <dinamic-table
    *ngIf="!loading && listPhotos.rows.length"
    [id]="'photoscontainer'+data.container_id"
    [data]="listPhotos"
    [frontpaginate]="true"
    (action_button)="action($event)"
  ></dinamic-table>

</div>
<div mat-dialog-actions>
  <button mat-button class="btn btn-default" (click)="onNoClick()">close</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
</div>